module.exports = __webpack_public_path__ + "static/media/es.bcf1ab98.svg";